﻿import jQuery from 'jquery';
; (function (window, $, document, unknown) {
    const ftExpires = new Date();
    ftExpires.setFullYear(new Date().getFullYear() + 1);
    let cookiesCleared = false;

    var utmCookies = {
        init: function () {
            this.build();
        },
        clearUtmCookies: function (domain) {
            const cookies = ["utm_source", "utm_campaign", "utm_term", "utm_content", "utm_medium"];
            cookies.forEach((e) => {
                document.cookie = e + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=" + domain + ";";
            });
        },
        setFirstTouchCookie: function (domain, key, value) {
            const re = new RegExp(`^(.*;)?\\s*${key}_ft\\s*=`);
            if (document.cookie.match(re))
                return;

            document.cookie = `${key}_ft=${value};path=/;domain=${domain};expires=${ftExpires.toUTCString()}`;
        },
        build: function () {
            const url = window.location; // parse the current page URL
            const domain = this.getDomain();
            const queryString = url.search;
            const queryParameters = queryString.split("&");
            for (let i = 0; i < queryParameters.length; i++) {
                const parameterPair = queryParameters[i].split("=");
                const key = parameterPair[0];
                const value = parameterPair[1];
                if (key.startsWith("utm_")) {

                    // only run once if there utm querystring exists
                    if (!cookiesCleared) {
                        this.clearUtmCookies(domain);
                        cookiesCleared = true;
                    }
                    this.setFirstTouchCookie(domain, key, value);
                    document.cookie = `${key}=${value}; path=/; domain=${domain};`;
                }
            }

        },
        getDomain: function () {
            var domain = document.domain;
            let i = 0;
            const parts = domain.split(".");
            const value = "km_" + (new Date()).getTime();
            while (i < (parts.length - 1) && document.cookie.indexOf(value + "=" + value) === -1) {
                domain = parts.slice(-1 - (++i)).join(".");
                document.cookie = value + "=" + value + ";domain=" + domain + ";";
            }
            document.cookie = value + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=" + domain + ";";
            return domain;

        }

    }
    $(function () {
        utmCookies.init();
    });

}(window, jQuery, document));
